/**
 * @author robin
 * @description maintain all long time api request paths
 */
// function getAmortizePaths() {
//     return []
// }

// const AmortizePaths = []

export default [
    // 摊销
    '/amortize/income/list/all',
    '/amortize/expenditure/list/all',
    '/amortize/income/unroll/list',
    '/amortize/expenditure/unroll/list',
    '/amortize/income/export/all',
    '/amortize/expenditure/export/all',
    '/amortize/expenditure/status/list',
    '/amortize/budget/list',
    '/amortize/budget/export/all',
    '/amortize/budget/unroll/list',
    
    '/house/list/houseSpaceInHouseSpaceManager/v2',
]
// .concat(getAmortizePaths()).concat(AmortizePaths)



// WEBPACK FOOTER //
// ./src/xhr/longTimeApiEnum.js